//
//
//
//
//
//
//

import  { mapGetters, mapActions } from "vuex";
import InvoiceLookup from "./components/invoice-lookup"
import PaymentForm from "./components/payment-form"

export default {
  name: "OnlineBillPaay",
	components: {
		InvoiceLookup,
		PaymentForm
	},
  data: function () {
    return {
    	mode: 'invoice'
    };
  },
  computed: {
		...mapGetters(["config", "loading"]),
	},
  methods: {
		...mapActions(["loadConfig", "resetData"]),
	  resetApp() {
			this.goBack();
			this.resetData();
	  },
	  proceedToPayment() {
			this.mode = 'payment';
		  document.querySelectorAll('.HideOnStep2').forEach((el) => {
			  el.style.display = 'none';
		  });
	  },
	  goBack() {
		  this.mode = 'invoice';
		  document.querySelectorAll('.HideOnStep2').forEach((el) => {
			  el.style.display = 'block';
		  });
	  }
	},
	created() {
		this.loadConfig(this.$root.config);
		console.log(new Date().toISOString());
	}
};
